// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import generatePDF from "./components/shared/generatePDF.vue";
import generatePDFAssessment from "./components/shared/generateAssessmentPDF.vue";
import VueRouter from "vue-router";
import axios from "axios";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Echo from "laravel-echo";

import {
  Repository
} from "./repositories/Repository";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";

import datePicker from "vue-bootstrap-datetimepicker";
import "bootstrap/dist/css/bootstrap.css";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

/* <link rel="stylesheet" href="../static/static-css/style.css">
  <link rel="stylesheet" href="../static/css/style.css">
  <link rel="stylesheet" href="../static/scss/style.css"> */

import "../static/css/style.css";
import "../static/scss/style.css";
import "../static/static-css/style.css";

// import '../static/static-css/bootstrap.min.css'
// -----------------------------------------------commented this bs 3
import "../static/static-css/elegant-font.css";
import "../static/static-css/owl.carousel.css";
import "../static/static-css/video.min.css";
import "../static/static-css/animate.css";
// import "../static/static-css/style.css";

import "../static/static-css/responsive.css";
// css imports end here

// css imports end here

import LoadScript from "vue-plugin-load-script";
// import DatatableFactory from 'vuejs-datatable'
// Store/Vuex
import {
  store
} from "./store/store";
import {
  routes
} from "./routes/routes";
import GuestLayout from "./layouts/GuestLayout.vue";
import MemberLayout from "./layouts/MemberLayout.vue";
import VueLodash from "vue-lodash";
import VueMoment from "vue-moment";
import {
  VTooltip,
  VPopover,
  VClosePopover
} from "v-tooltip";

import JQuery from "jquery";
import moment from "moment";
import VuePhoneNumberInput from "vue-phone-number-input";
import JsonExcel from "vue-json-excel";
/**
 * Google Ads
 */
import Ads from "vue-google-adsense";
import IdleVue from "idle-vue";
import "./registerServiceWorker";
window.io = require("socket.io-client");
Vue.use(VueToast);

Vue.use(require("vue-script2"));

Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);
/**
 * Google Ada
 */
Vue.component("downloadExcel", JsonExcel);
Vue.component("vue-phone-number-input", VuePhoneNumberInput);
Vue.use(VueLodash);
Vue.use(LoadScript);
window.$ = JQuery;
Vue.directive("tooltip", VTooltip);

Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);
// window._ = VueLodash
Vue.use(VueMoment);
Vue.component("guest-layout", GuestLayout);
Vue.component("member-layout", MemberLayout);
Vue.component("generate-pdf", generatePDF);
Vue.component("generate-pdf-Assessment", generatePDFAssessment);
/* options for autonumeric */

let autoNumericOptions = {
  negativeBracketsTypeOnBlur: "(,)",
  decimalPlaces: "0",
  modifyValueOnWheel: false,
  decimalPlacesShownOnBlur: 0,
  // decimalPlacesShownOnFocus: 3,
  roundingMethod: "S",
  selectOnFocus: true
};
let readOnlyAutoNumericOptions = {
  readOnly: true,
  noEventListeners: true // ,
  // decimalPlaces: '3'
};

Object.assign(readOnlyAutoNumericOptions, autoNumericOptions);

localStorage.setItem("autoNumericOptions", JSON.stringify(autoNumericOptions));
localStorage.setItem(
  "readOnlyAutoNumericOptions",
  JSON.stringify(readOnlyAutoNumericOptions)
);

Vue.config.productionTip = false;
// Register router
Vue.use(VueRouter);
Vue.use(datePicker);

Vue.filter("formatDate", value => {
  if (value) {
    return moment(String(value)).format("YYYY-MM-DD");
  }
});
const router = new VueRouter({
  mode: "history",
  saveScrollPosition: false,
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  },
  linkActiveClass: "active",
  linkExactActiveClass: "active"
});

const options = {
  confirmButtonColor: "#008000",
  cancelButtonColor: "#ff7674"
};

Vue.use(VueSweetalert2, options);
/* Axios to $http */
Vue.prototype.$http = axios;
/* Router transition */
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
  store.state.loadedComponent = to.meta.identify;
  window.letidentify = to.meta.identify;
  store.state.burgerMenus = [{
      name: "Home",
      link: `${process.env.HOST}`,
      hasChild: false
    },
    {
      name: "Products",
      link: `${process.env.HOST}#products`,
      hasChild: false
    },
    {
      name: "Russian Financial Statements Translation",
      link: `${process.env.HOST}/financial-statements`,
      hasChild: false
    },
    {
      name: "Pricing",
      link: `${process.env.HOST}#pricing`,
      hasChild: false
    },
    {
      name: "FAQ",
      link: `${process.env.HOST}/faqs`,
      hasChild: false
    },
    {
      name: "Contact",
      link: `${process.env.HOST}#testimonial`,
      hasChild: false
    },
    {
      name: "Target Customers",
      link: `${process.env.HOST}/target-customers`,
      hasChild: false
    },
    {
      name: "Our Customers",
      link: `${process.env.HOST}/our-customers`,
      hasChild: false
    },
    {
      name: "Testimonials",
      link: `${process.env.HOST}/testimonials`,
      hasChild: false
    },
    {
      name: "About",
      link: `${process.env.HOST}/about`,
      hasChild: false
    }
  ];
  store.state.menus = [{
      name: "Home",
      link: `${process.env.HOST}`,
      hasChild: false
    },
    {
      name: "Products",
      link: `${process.env.HOST}#products`,
      hasChild: true,
      childs: [{
        name: "Russian Financial Statements Translation",
        link: `${process.env.HOST}/financial-statements`,
        hasChild: false
      }]
    },
    {
      name: "Pricing",
      link: `${process.env.HOST}#pricing`,
      hasChild: false
    },
    {
      name: "FAQ",
      link: `${process.env.HOST}/faqs`,
      hasChild: false
    },
    {
      name: "Contact",
      link: `${process.env.HOST}#testimonial`,
      hasChild: false
    },
    {
      name: "Customers",
      link: "#",
      hasChild: true,
      childs: [{
          name: "Target Customers",
          link: `${process.env.HOST}/target-customers`,
          hasChild: false
        },
        {
          name: "Our Customers",
          link: `${process.env.HOST}/our-customers`,
          hasChild: false
        },
        {
          name: "Testimonials",
          link: `${process.env.HOST}/testimonials`,
          hasChild: false
        }
      ]
    },
    {
      name: "About",
      link: `${process.env.HOST}/about`,
      hasChild: false
    }
    // {
    //   name: 'Legal',
    //   link: '#',
    //   hasChild: true,
    //   childs: [{
    //     name: 'Disclaimer',
    //     link: `${process.env.HOST}/disclaimer`,
    //     hasChild: false
    //   },
    //   {
    //     name: 'Privacy Policy',
    //     link: `${process.env.HOST}/privacy-policy`,
    //     hasChild: false
    //   }
    //   ]
    // }
  ];

  const token = localStorage.getItem("token");
  if (token) {
    store.commit("MountUserForMainJS");
    store.state.transformationInputOne.miscData = JSON.parse(
      localStorage.getItem("miscData")
    );
    Repository.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
  store.state.errors = "";
  const authRequired = to.matched.some(route => route.meta.auth);
  const isLoggedIn = store.state.user.isLoggedIn;
  // const anaylasisCounter = store.state.user.loggedInUser.activeplan.anaylasisCounter
  // const toTransformationInput = (to.path === 'transformation-input')
  if (authRequired && !isLoggedIn) {
    next("/login");
    return false;
  } else if (
    isLoggedIn &&
    (to.path === "/login" ||
      to.path === "/register" ||
      to.path === "/forgotPassword" ||
      to.path === "/resetPassword" ||
      to.path === "/LoginOTP")
  ) {
    next("/");
    return false;
  } else if (
    isLoggedIn &&
    to.path === "/transformation-input/FinancialStatements"
  ) {
    if (
      store.state.user.loggedInUser.counter !== 0 &&
      store.state.user.loggedInUser.counter !== null
    ) {
      // store.state.user.loggedInUser.activeplan.anaylasisCounter !== 0 && store.state.user.loggedInUser.activeplan.anaylasisCounter !== null
      // (anaylasisCounter !== 0 && anaylasisCounter !== null)
      next();
      return false;
    } else {
      next("/financialStatmentsTranslation-plans");
      return false;
    }
  }
  if (
    isLoggedIn &&
    to.path === "/customerProfile" &&
    from.path === "/register"
  ) {
    store.commit("DISPLAYTOAST", true);
  }
  if (isLoggedIn && to.path === "/checkout") {
    if (from.path !== "/financialStatmentsTranslation-plans") {
      next("/financialStatmentsTranslation-plans");
      return false;
    } else {
      next();
      return false;
    }
  } else {
    next();
    return false;
  }
});

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 900000, // 15 Minutes 900000
  startAtIdle: false
});

// window.Echo = new Echo({
//   broadcaster: 'socket.io',
//   host: window.location.hostname + ':6001',
//   auth: {
//     headers: {
//       Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsdW1lbi1qd3QiLCJzdWIiOjY1LCJpYXQiOjE2MDM2OTM2MTcsImV4cCI6MTYwMzc4MDAxNywiaXNBZG1pbiI6ZmFsc2V9.g2Lxe5tWbuozdFVq2odKSX_9H7w4Oyt4ailCapq_kEA'
//     }
//   }
// })
// // window.Echo.channel('example-channel')
// window.Echo.private('example-channel')
//   .listen('NewMessageEvent', (e) => {
//     console.log('hello', e)
//   }).error(err => console.log('error', err))

/* eslint-disable no-new */
window.root = new Vue({
  el: "#app",
  router: router,
  store: store,
  render: h => h(App)
});
Vue.routerInstance = router;



// WEBPACK FOOTER //
// ./src/main.js